namespace TabAurous.Production {
    export namespace QualityInspectionValuesService {
        export const baseUrl = 'Production/QualityInspectionValues';

        export declare function Create(request: Serenity.SaveRequest<QualityInspectionValuesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<QualityInspectionValuesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<QualityInspectionValuesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<QualityInspectionValuesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/QualityInspectionValues/Create",
            Update = "Production/QualityInspectionValues/Update",
            Delete = "Production/QualityInspectionValues/Delete",
            Retrieve = "Production/QualityInspectionValues/Retrieve",
            List = "Production/QualityInspectionValues/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>QualityInspectionValuesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
